const INICIAL = {
    aguardando: false,
    lista: [],
    detalhe: null,
    tipos: [],
    minhaConta: null
};

export default (state = INICIAL, action) => {
    switch (action.type) {
        case 'CONTA_CORRENTE_AGUARDANDO':
            return { ...state, aguardando: action.payload };
        case 'CONTA_CORRENTE_LISTA':
            return { ...state, lista: action.payload };
        case 'CONTA_CORRENTE_DETALHE':
            return { ...state, detalhe: action.payload };
        case 'CONTA_CORRENTE_TIPOS':
            return { ...state, tipos: action.payload };
        case 'MINHA_CONTA_CORRENTE':
            return { ...state, minhaConta: action.payload };
        default:
            return state;
    }
};
